import { Component, inject, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

interface AppItem {
  id: string;
  name: string;
  avatar: string;
  route: string;
  disabled: boolean;
}

@Component({
  selector: 'app-apps-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule, CardModule, TranslocoPipe],
  templateUrl: './apps-dialog.component.html',
  styleUrls: ['./apps-dialog.component.scss'],
})
export class AppsDialogComponent implements OnInit, OnDestroy {
  private ref = inject(DynamicDialogRef);
  private cdr = inject(ChangeDetectorRef);
  private translocoService = inject(TranslocoService);

  apps: AppItem[] = [
    {
      id: 'meeting-assistant',
      name: 'Meeting Assistant',
      avatar: '👥',
      route: 'https://summarize.demisco.ai/',
      disabled:false,
    },
    {
      id: 'farahoush',
      name: 'Intelligent Monitoring System (IMS, CCTV)',
      avatar: '🤖',
      route: 'https://ims.demisco.ai/',
      disabled:true,
    },
    {
      id: 'call-center',
      name: 'AI-Enabled Call Center',
      avatar: '📞',
      route: 'https://contactcenter.demisco.ai/',
      disabled:true,
    },
    {
      id: 'textra',
      name: 'Textra (image to DB)',
      avatar: '⚡',
      route: 'https://textra.demisco.ai/',
      disabled:true,
    },
    {
      id: 'avatar',
      name: 'AI Avatar Assistant',
      avatar: '💻',
      route: 'https://ml.demisco.ai/avatar-assistant/',
      disabled:true,
    },
  ];

  ngOnInit() {
    this.setupBrowserBackButtonHandler();
  }

  ngOnDestroy() {
    this.removeBrowserBackButtonHandler();
  }

  navigateToApp(route: string) {
    if (!route) return;
    window.open(route, '_blank', 'noopener,noreferrer');
    this.close();
  }

  getAppDescription(appName: string): string {
    const descriptions: { [key: string]: string } = {
      'Intelligent Monitoring System (IMS, CCTV)': 'appsDialog.descriptions.intelligentMonitoringSystem',
      'AI-Enabled Call Center': 'appsDialog.descriptions.aiEnabledCallCenter',
      'Meeting Assistant': 'appsDialog.descriptions.meetingAssistant',
      'Textra (image to DB)': 'appsDialog.descriptions.textra',
      'AI Avatar Assistant': 'appsDialog.descriptions.aiAvatarAssistant',
    };
    return descriptions[appName] || 'appsDialog.descriptions.default';
  }

  // Browser back button handling
  private popStateHandler = () => {
    this.close();
  };

  private setupBrowserBackButtonHandler() {
    // Push a state to the history to detect back button press
    history.pushState({ dialogOpen: true }, '');
    window.addEventListener('popstate', this.popStateHandler);
  }

  private removeBrowserBackButtonHandler() {
    window.removeEventListener('popstate', this.popStateHandler);
  }

  close() {
    this.ref.close();
  }
}
